<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { openService } from "@/utils/common";
import config from "./config/index";
// // import { getTime } from "@/utils/tools";
// import fetch from "@/utils/fetch";
// import { showToast } from "@/utils/h5";s
export default {
  data() {
    return {
      // subCode: "znjp_data",
      // loginFlag: this.$root.loginFlag, //登陆状态
      // accountNo: "",
      // fundLoginFlag: false //资金账号登录
    };
  },
  created() {
    var that = this;
    var ua = navigator.userAgent.toLowerCase();

    // 获取链接后的key值
    var params = that.getQueryString("key");
    var key = params ? `?key=${params}` : "";
    // console.log(window.location.href,'路径')
    that.$root.key = key;
    // console.log("app", key);
    if (ua.indexOf("gydj") != -1) {
      that.$root.channel = "gydj";
      this.$root.appFlag = true;
      var JSONData = {
        right: {
          style: "0",
          showNum: "1",
          items: [
            {
              openSource: "MARKET_DATA_DT",
              functionCode: "FN_EMBED_H5_SHARE",
              openType: "5",
              param: {
                title: "国元证券818理财直播节",
                content: "抽盲盒，看直播，赢红包，与国元证券一起科学理财",
                URLString: config.F_BASEURL + "/818lcj/index.html"
                // URLString:"http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsATmb6YXjxvUVmNbbM0srJNJwxXYWudaaT41pRYq9WPcbrvNVQ6EWFZ%E5%8A%A0%E5%8F%B7KftCTulf08Lj88xO2dS12EpiiG33kR8gyrlM3KUby6GmPfUPYJPi38rIDTrh2LbFlzAs%E5%8A%A0%E5%8F%B7R8cveTA=="
              },
              simpleName: "分享",
              imageWhite: "navigationBarShareWhite"
            }
          ]
        }
      };
      openService("", "5", "FN_EMBED_H5_TOPMENUCONTROL", JSONData);
    } else {
      // this.$root.channel = "weixin";
      that.$root.channel = "qita";

      if(window.location.href.indexOf("invitacode") > -1 &&
        window.location.href.indexOf("key") > -1){
        that.$router.replace("/invitation")
      }
    }
  },
  methods: {
    getQueryString: function(param) {
      // var qs = location.search.substr(1); // 获取url中"?"符后的字串
      var url = window.location.href;
      var index = url.indexOf("?");

      var qs = url.substr(index + 1);
      // var qs = location.search.substr(1); // 获取url中"?"符后的字串·
      var args = ""; // 保存参数数据的对象
      var items = qs.length ? qs.split("&") : []; // 取得每一个参数项

      var len = items.length;

      for (var i = 0; i < len; i++) {
        var pair = items[i].split("=");
        if (pair[0] == param) {
          args = param == 'key' ? decodeURIComponent(pair[1]) : pair[1];
          return args;
        }
      }
      return args;
    }
  }
};
</script>

<style>
#app {
  height: 100%;
}
</style>
